import { useState } from 'react';
import styled from 'styled-components';
import { isNull, isEmpty } from 'lodash';
import { Grid } from '@material-ui/core';
import SlaIcon from 'images/time.svg';
import warning from 'images/warningoutlined.svg';
import timerDot from 'images/timerDot.svg';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { IntlShape, injectIntl } from 'react-intl';
import { IconButton, Collapse } from '@material-ui/core';
import messages from 'containers/AppContainer/messages';
import withLoading from 'containers/AppContainer/withLoading';
import { LOADERS } from 'containers/AppContainer/Loader/constants';
import { CollapseContainer } from 'containers/LawyerFeeNote/styled-components';
import TimeAgo from 'timeago-react';
import checkIcon from 'images/check_small.svg';
import doubleCheckIcon from 'images/double-check-icon.svg';
import { Collapsible } from 'containers/LawyerDocumentsPage/typings';
import { translate } from 'containers/services/translate';
import { getTimeDifference } from 'containers/AppContainer/utils';

interface StyledGridProps {
  color?: string;
}

export const Container = styled.div`
  text-align: left;
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
  padding: 24px;
  font-weight: 500;
  width: 520px;
  .notification-container {
    width: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
    margin-top: 3px;
  }
`;
export const StyledGrid = styled(Grid)<StyledGridProps>`
  margin-top: 5px;
  background-color: ${props => (props.color ? props.color : '#e6f1fa')};
  border-radius: 5px;
  padding: 20px;
  font-weight: 300;
`;
export const StyledBinGrid = styled(Grid)`
  margin-top: 5px;
`;
export const StyledImg = {
  marginTop: '3px',
  width: '16px',
  height: '16px',
};
export const StyledSpan = {
  color: '#5493BD',
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: 400,
};
export const StyledSpanCheck = {
  color: '#10BB00',
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: 400,
};

export const StyledSlaContainer = {
  padding: '6px 6px 6px 6px',
  border: '1px solid #0075C9',
  borderRadius: '92px',
  backgroundColor: '#FFFFFF',
};
export const StyledWarningContainer = {
  padding: '6px 6px 6px 6px',
  border: '1px solid rgba(255, 140, 0, 1)',
  borderRadius: '92px',
  backgroundColor: 'rgba(255, 255, 255, 1)',
};
export const StylePendingContainer = {
  background: 'rgba(230, 241, 250, 1)',
  borderRadius: '92px',
  padding: '6px 6px 6px 6px',
};
export interface InboxeProps {
  intl: IntlShape;
  title: string;
  count?: number;
  expandRow: any;
  setExpandRow: any;
  loaders: any;
  index: any;
  managerNotifications?: any;
  managerInboxesId: any;
  handleClickNotificationInboxe: Function;
  sla: number;
  maxNotification: string;
  lawyerNotifications: any;
}

const Inboxe = (props: InboxeProps) => {
  const [selectedInboxeId, setSelectedInboxeId] = useState(null);

  const getNotifications = () => {
    if (!isEmpty(props.managerNotifications)) {
      return props.managerNotifications.filter(
        (el: any) =>
          (Number(selectedInboxeId) ===
            Number(el.managerNotificationType?.managerInboxesId) ||
            Number(selectedInboxeId) === Number(el.transactionInboxeAreaId)) &&
          el.readBy === null,
      );
    } else if (!isEmpty(props.lawyerNotifications)) {
      return props.lawyerNotifications;
    } else {
      return [];
    }
  };

  const getColor = (notif: any) => {
    if (notif.readBy !== null) return '#f5f9fc';
  };

  return (
    <Container>
      <Grid container direction="row" alignItems="center" spacing={1}>
        <StyledBinGrid item xs={1}>
          <IconButton
            aria-label="expand-row"
            size="small"
            data-testid={'expand-icon'}
            onClick={() => {
              let rowsToExpand: Collapsible;
              if (props.expandRow !== undefined) {
                rowsToExpand = {
                  ...props.expandRow,
                };
                //@ts-ignore
                rowsToExpand[props.index] = !rowsToExpand[props.index];
              } else {
                rowsToExpand = undefined;
              }
              props.setExpandRow(rowsToExpand);
              setSelectedInboxeId(props.managerInboxesId);
            }}
          >
            {props.expandRow && props.expandRow[props.index] ? (
              <KeyboardArrowUpIcon />
            ) : (
              <KeyboardArrowDownIcon />
            )}
          </IconButton>
        </StyledBinGrid>
        <StyledBinGrid item xs>
          {props.title}
        </StyledBinGrid>
        {props.sla && (
          <Grid item>
            <Grid
              style={StyledSlaContainer}
              container
              direction="row"
              alignItems="center"
            >
              <Grid
                item
                style={{
                  marginTop: '3px',
                }}
              >
                <img src={SlaIcon} alt="sla icon" />
              </Grid>
              <Grid
                item
                style={{
                  color: 'rgba(0, 117, 201, 1)',
                  fontSize: '14px',
                  marginTop: '-3px',
                  marginLeft: '2px',
                }}
              >
                {'SLA: ' + props.sla + ' j'}
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid item>
          <Grid
            style={StyledWarningContainer}
            container
            direction="row"
            alignItems="center"
          >
            <Grid
              item
              style={{
                marginTop: '3px',
              }}
            >
              <img src={warning} alt="wrning icon" />
            </Grid>
            <Grid
              item
              style={{
                color: 'rgba(255, 140, 0, 1)',
                fontSize: '14px',
                marginLeft: '2px',
              }}
            >
              {props.maxNotification + 'j'}
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid
            style={StylePendingContainer}
            container
            direction="row"
            alignItems="center"
          >
            <Grid
              item
              style={{
                marginTop: '3px',
              }}
            >
              <img src={timerDot} alt="time dot icon" />
            </Grid>
            <Grid
              item
              style={{
                color: 'rgba(0, 117, 201, 1)',
                fontSize: '14px',
                marginLeft: '2px',
              }}
            >
              {props.count + ' Dossiers'}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Collapse
        in={props.expandRow && props.expandRow[props.index]}
        timeout="auto"
        unmountOnExit
      >
        <CollapseContainer>
          {getNotifications().map((el: any) => (
            <div style={{ cursor: 'pointer' }}>
              <StyledGrid
                container
                direction="row"
                data-testid={'button-notif'}
                onClick={() => props.handleClickNotificationInboxe(el)}
                color={getColor(el)}
              >
                <Grid item xs={getTimeDifference(el.created_at)?.days ? 10 : 8}>
                  {el.title}
                </Grid>
                <Grid item xs={getTimeDifference(el.created_at)?.days ? 2 : 4}>
                  {getTimeDifference(el.created_at)?.days ? (
                    <span style={{ textAlign: 'end', display: 'grid' }}>
                      {getTimeDifference(el.created_at)?.days + 'j'}
                    </span>
                  ) : (
                    <TimeAgo datetime={el.created_at} locale="fr" />
                  )}
                </Grid>
                {!el.treated && !isNull(el.readBy) && (
                  <Grid item xs={12}>
                    <Grid container direction="row" alignContent="center">
                      <Grid item>
                        <img
                          src={checkIcon}
                          style={StyledImg}
                          alt="check icon"
                        />
                      </Grid>
                      <Grid item>
                        <span style={StyledSpan}>
                          {translate(messages.readByTitle, props, {
                            username: el.readBy,
                          })}
                        </span>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                {el.treated && !isNull(el.treatedBy) && (
                  <Grid item xs={12}>
                    <Grid container direction="row" alignContent="center">
                      <Grid item>
                        <img
                          src={doubleCheckIcon}
                          style={StyledImg}
                          alt="double check icon"
                        />
                      </Grid>
                      <Grid item>
                        <span style={StyledSpanCheck}>
                          {translate(messages.treatedByTitle, props, {
                            username: el.treatedBy,
                          })}
                        </span>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </StyledGrid>
            </div>
          ))}
        </CollapseContainer>
      </Collapse>
    </Container>
  );
};

export default withLoading(injectIntl(Inboxe), [LOADERS.NOTIFICATION_INBOXES]);
